import React from 'react';

export default function FirstChatAfterSection() {
  return (
    <section id="first-chat-after" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #0a0814 0%, #0d0a14 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse at 50% 0%, rgba(56,189,248,0.07) 0%, transparent 60%)',
        pointerEvents: 'none',
      }} />
      {/* Moon & stars */}
      {['⭐','🌙','✨','💫','🌟'].map((e, i) => (
        <div key={i} style={{
          position: 'absolute', fontSize: `${12 + i * 3}px`, opacity: 0.2,
          top: `${5 + i * 15}%`,
          left: i % 2 === 0 ? `${5 + i * 4}%` : undefined,
          right: i % 2 !== 0 ? `${5 + i * 4}%` : undefined,
          animation: `twinkle ${2 + i}s ease-in-out infinite`,
          animationDelay: `${i * 0.4}s`,
        }}>{e}</div>
      ))}

      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 60, alignItems: 'center',
        }}>
          {/* Illustration */}
          <div style={{ display: 'flex', justifyContent: 'center', order: 0 }}>
            <div style={{ position: 'relative', animation: 'float 5s ease-in-out infinite' }}>
              <svg viewBox="0 0 280 280" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 280 }}>
                <defs>
                  <linearGradient id="eidGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#38bdf8" />
                    <stop offset="100%" stopColor="#a855f7" />
                  </linearGradient>
                  <radialGradient id="eidBg" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="rgba(56,189,248,0.1)" />
                    <stop offset="100%" stopColor="rgba(0,0,0,0)" />
                  </radialGradient>
                </defs>
                <circle cx="140" cy="140" r="120" fill="url(#eidBg)" />
                <circle cx="140" cy="140" r="110" fill="none" stroke="rgba(56,189,248,0.15)" strokeWidth="1" strokeDasharray="8 5" />

                {/* Boy - happy, jumping */}
                <circle cx="100" cy="95" r="24" fill="#2d1f4a" />
                <circle cx="92" cy="90" r="5" fill="#a855f7" />
                <circle cx="108" cy="90" r="5" fill="#a855f7" />
                <circle cx="92" cy="90" r="2.5" fill="#1a0a2e" />
                <circle cx="108" cy="90" r="2.5" fill="#1a0a2e" />
                <circle cx="92" cy="89" r="1.2" fill="white" opacity="0.8" />
                <circle cx="108" cy="89" r="1.2" fill="white" opacity="0.8" />
                {/* Big smile */}
                <path d="M92,106 Q100,116 108,106" stroke="#ff9db5" strokeWidth="2.5" fill="none" strokeLinecap="round" />
                {/* Blush */}
                <circle cx="87" cy="100" r="6" fill="#ff9db5" opacity="0.25" />
                <circle cx="113" cy="100" r="6" fill="#ff9db5" opacity="0.25" />
                <rect x="78" y="119" width="44" height="52" rx="12" fill="#3d2a6a" />
                <rect x="78" y="119" width="44" height="22" rx="10" fill="url(#eidGrad)" />
                {/* Arms up in joy */}
                <path d="M78,130 Q60,115 55,105" stroke="#3d2a6a" strokeWidth="13" strokeLinecap="round" fill="none" />
                <path d="M122,130 Q140,115 145,105" stroke="#3d2a6a" strokeWidth="13" strokeLinecap="round" fill="none" />

                {/* Celebration emojis */}
                <text x="50" y="95" fontSize="18">🎉</text>
                <text x="140" y="85" fontSize="16">✨</text>
                <text x="120" y="60" fontSize="14">🌟</text>
                <text x="72" y="55" fontSize="12">💫</text>

                {/* Eid crescent */}
                <path d="M190,50 Q210,55 215,75 Q205,60 190,50Z" fill="#ffd700" />
                <circle cx="215" cy="75" r="20" fill="#ffd700" opacity="0.15" />

                {/* Phone showing message */}
                <rect x="175" y="120" width="85" height="130" rx="12" fill="#1a1228" stroke="rgba(56,189,248,0.3)" strokeWidth="1.5" />
                <rect x="181" y="128" width="73" height="114" rx="8" fill="#0d0a14" />
                <rect x="202" y="124" width="34" height="4" rx="2" fill="#2d1f4a" />

                {/* Eid message bubbles */}
                <rect x="185" y="140" width="65" height="20" rx="8" fill="url(#eidGrad)" opacity="0.9" />
                <text x="217" y="154" textAnchor="middle" fill="white" fontSize="8" fontFamily="Nunito, sans-serif">Eid Mubarak! 🌙</text>
                <rect x="185" y="168" width="60" height="20" rx="8" fill="#2d1f4a" />
                <text x="215" y="182" textAnchor="middle" fill="#e2c8d8" fontSize="8" fontFamily="Nunito, sans-serif">Eid Mubarak 💕</text>
                <rect x="185" y="196" width="58" height="20" rx="8" fill="url(#eidGrad)" opacity="0.9" />
                <text x="214" y="210" textAnchor="middle" fill="white" fontSize="7.5" fontFamily="Nunito, sans-serif">Miss kar rha tha!</text>

                {/* Heart trail */}
                <text x="155" y="185" fontSize="14" style={{ animation: 'float 2s ease-in-out infinite' }}>💕</text>
                <text x="158" y="210" fontSize="10" style={{ animation: 'float 3s ease-in-out infinite 0.5s' }}>❤️</text>
              </svg>
            </div>
          </div>

          {/* Text */}
          <div>
            <div className="section-badge" style={{ borderColor: 'rgba(56,189,248,0.3)', background: 'rgba(56,189,248,0.08)' }}>
              <span>🌙</span> Chapter 8
            </div>
            <h2 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 800,
              fontSize: 'clamp(32px, 6vw, 54px)', lineHeight: 1.15, marginBottom: 8,
            }}>
              First Chat <span style={{
                background: 'linear-gradient(135deg, #38bdf8, #a855f7)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}>After Waiting</span>
            </h2>
            <div className="section-divider" style={{ background: 'linear-gradient(90deg, #38bdf8, #a855f7)' }} />
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 18px',
              background: 'rgba(56,189,248,0.08)',
              border: '1px solid rgba(56,189,248,0.2)',
              borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
              color: '#38bdf8', marginBottom: 24,
            }}>
              🌙 Eid ul Fitr
            </div>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 20,
            }}>
              After the waiting, after the silence, after counting days — Eid ul Fitr arrived and with it came the message Hassan had been hoping for. That notification was more beautiful than any Eidi. 🌙✨
            </p>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 32,
            }}>
              When Fiza's name appeared on the screen with "Eid Mubarak," Hassan's heart leapt with pure happiness. The wait was worth it. Every single second. This conversation was a reminder that patience always wins. 💕
            </p>

            <div style={{
              background: 'linear-gradient(135deg, rgba(56,189,248,0.08), rgba(168,85,247,0.06))',
              border: '1px solid rgba(56,189,248,0.2)',
              borderRadius: 20, padding: 24, marginBottom: 32,
            }}>
              <p style={{
                fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.8,
                color: '#e2c8d8', fontStyle: 'italic',
              }}>
                "After a long wait, even a simple 'Eid Mubarak' feels like the world. 🌙"
              </p>
            </div>

            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {['🌙 Eid ul Fitr', '💕 First Message', '😊 Happiness', '⏳ Worth the Wait'].map(t => (
                <span key={t} style={{
                  padding: '8px 16px',
                  background: 'rgba(56,189,248,0.06)',
                  border: '1px solid rgba(56,189,248,0.12)',
                  borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 13,
                  color: '#38bdf8',
                }}>{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}